import {Injectable} from '@angular/core';
import {LocationAccuracy} from '@ionic-native/location-accuracy';
import {Geolocation} from '@ionic-native/geolocation';
import {Diagnostic} from '@ionic-native/diagnostic';
import {ModalController} from 'ionic-angular';

@Injectable()
export class LocationServiceProvider {
  locationPerm = null;
  gpsOn = null;
  static GPS_TIMEOUT = 60000;
  constructor(private locAcc: LocationAccuracy, private geoloc: Geolocation,
    private modalController: ModalController, private diag: Diagnostic) {

  }

  getLocation() {
    return new Promise((resolve, reject) => {
      this.checkRequirements().then(() => {
        if(!this.areRequirementsMet()) {
          let m = this.modalController.create('LocationErrorPage',
            { locationPerm: this.locationPerm, gpsOn: this.gpsOn }
          );
          m.onWillDismiss((d) => {
            if(!d) {
              reject();
            }
            this.pullLocation(LocationServiceProvider.GPS_TIMEOUT).then(loc => resolve(loc)).catch(err => reject(err));
          });
          m.present();
        } else {
          this.pullLocation(LocationServiceProvider.GPS_TIMEOUT).then(loc => resolve(loc)).catch(err => reject(err));
        }
      });
    });
  }

  areRequirementsMet() {
    return this.locationPerm && this.gpsOn;
  }

  checkRequirements(): Promise<any> {
    return new Promise((resolve, reject) => {
      let resolveIf = () => {
        if(this.locationPerm != undefined && this.gpsOn != undefined) {
          console.log('REQUIREMENTS:', this.locationPerm, this.gpsOn);
          resolve({ locationPerm: this.locationPerm, gpsOn: this.gpsOn });
        }
      }
      this.diag.getLocationAuthorizationStatus().then(
        status => {
          this.locationPerm = this.diag.permissionStatus.GRANTED === status || this.diag.permissionStatus.GRANTED_WHEN_IN_USE === status;
          resolveIf();
        },
        err => {
          this.locationPerm = false;
          resolveIf();
        }
      );
      this.diag.isLocationEnabled().then(
        (r) => { this.gpsOn = r; resolveIf() },
        () => { this.gpsOn = false; resolveIf() }
      );
    });
  }

  checkPerm() {
    return new Promise(resolve => {
      this.diag.requestLocationAuthorization(this.diag.locationAuthorizationMode.ALWAYS).then(res => {
        this.locationPerm = res === this.diag.permissionStatus.GRANTED || res === this.diag.permissionStatus.GRANTED_WHEN_IN_USE;
        resolve(this.locationPerm);
      })
    });
  }

  checkGps() {
    return new Promise(resolve => {
      this.locAcc.request(this.locAcc.REQUEST_PRIORITY_HIGH_ACCURACY).then(
        () => { this.gpsOn = true; resolve(true); },
        () => { this.gpsOn = false; resolve(false); }
      );
    });
  }

  pullLocation(timeout) {
    return new Promise((resolve, reject) => {
      this.geoloc.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: timeout,
        maximumAge: 5 * 60000
      }).then(
        data => {
          resolve({lat: data.coords.latitude, lng: data.coords.longitude});
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/location-service/location-service.ts